<ng-container *ngIf="course">
  <div class="container-area flex-row-container" *ngIf="course?.information?.assessment">
    <div class="simulation-poster-container">
      <div class="poster-image" [style.backgroundImage]="'url(' + (course.postermedia?.path || '/assets/wonda/background2_ld.jpg')  + ')'">
      </div>
    </div>
    <div class="flex-column-container">
      <div class="assessment-title-container flex-row-container programs-h5">
        <span class="assessment-title text-truncate">{{ course?.title }}</span>
        <span class="assessment-title-reports">reports</span>
      </div>
      <div class="assessment-info-parent">
        <div class="assessment-info-column">
          <div class="assessment-info-title">Assessment Criteria</div>
          <div class="assessment-info-list programs-body-1">
            <ng-container *ngFor="let criteria of criteriaArray">
              <div class="assessment-info-item text-truncate">
                <b class="criteria-index">{{ criteria[0] + 1 }} -</b>
                <span>{{ criteria[1].title }}</span>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="assessment-info-column">
          <div class="assessment-info-title">Chart Legend</div>
          <div class="assessment-info-list programs-body-1">
            <div class="assessment-info-item">
              <span class="legend-indicator legend-indicator-blue"></span>
              <span>Individual’s score</span>
            </div>
            <div class="assessment-info-item">
              <span class="legend-indicator legend-indicator-gray"></span>
              <span>Group median</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <assessment [course]="course" [programsMode]="true" (onExplore)="onExplore($event)"></assessment>
</ng-container>
